import React from 'react'
import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'

import Header from './Header'
import Footer from './Footer'
import styled from 'styled-components'

const { Content } = Layout

const LayoutComponent = (props) => {
  return (
    <Layout>
      <Header />

      <Content
        style={{
          background: 'var(--white)',
        }}
      >
        <div
          style={{
            background: 'var(--white)',
          }}
        >
          <Outlet />
        </div>
      </Content>

      <Footer />
    </Layout>
  )
}

export default LayoutComponent

export const Container = styled.div`
  height: 100%;
  margin: 0;

  .site-layout-content {
    background: var(--white);
    overflow: auto;
  }
`
